// ── Connector settings (mockup, not persisted) ──────────────────────────────
//
// Part of the "Additional config" section of the node drawers: mocks the idea
// of "set the AWS secret path / endpoint for this provider's connector right
// here, instead of editing a raw config file". This is placeholder-only — it
// keeps its own local state and does NOT write to the workflow JSON.
import { useState } from 'react'
import { Field, TextInput, Toggle } from './fields'

export interface ConnectorConfigProps {
  providerLabel?: string
  secretPathPlaceholder?: string
}

interface ConnectorSettings {
  awsSecretPath: string
  endpoint: string
  enabled: boolean
}

export function ConnectorConfig({ providerLabel, secretPathPlaceholder }: ConnectorConfigProps) {
  const [connector, setConnector] = useState<ConnectorSettings>({ awsSecretPath: '', endpoint: '', enabled: true })
  const patch = (p: Partial<ConnectorSettings>) => setConnector((c) => ({ ...c, ...p }))

  return (
    <div className="flex flex-col gap-3">
      <p className="text-[10px] uppercase tracking-wide text-[#5b6b85]">
        Connector{providerLabel ? ` — ${providerLabel}` : ''}
      </p>

      <Field label="AWS secret path">
        <TextInput
          value={connector.awsSecretPath}
          onChange={(e) => patch({ awsSecretPath: e.target.value })}
          placeholder={secretPathPlaceholder ?? '/frankieone/{customer}/con_provider'}
        />
      </Field>

      <Field label="Endpoint">
        <TextInput
          value={connector.endpoint}
          onChange={(e) => patch({ endpoint: e.target.value })}
          placeholder="https://provider.example.com/api"
        />
      </Field>

      <Toggle label="Enabled" checked={connector.enabled} onChange={(v) => patch({ enabled: v })} />
    </div>
  )
}
